import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
// remove this dependency after 18.06.2025. this is GA
export const useNewDataModel = () => {
  return true;
};
